import {reactive} from "vue";

export const eventBus = reactive({
    textValidation: true,
    forceQualityRecheck: false,
});
